import { EvesTextbox } from '@/common/components/atoms/textbox/textbox';
import { Grid } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const MercedesConnection = (props: any) => {
	const { t: translate } = useTranslation();
	
	return <Grid container rowSpacing={1} columnSpacing={2} sx={{ marginTop:'8px'}}>
		<Grid item xs={6}>
			<Controller name="mercedesConnection.authenticationUrl" control={props.carConnectorForm.control} render={({ field }) => (
				<EvesTextbox {...field} id="authenticationUrl" label={`${translate('settings.car_connector.connection.authentication_url')} *`}
					data-cy="refunding-authenticationUrl"
					fullWidths
					variant="standard" 
					error={!!props.carConnectorForm.formState?.errors.mercedesConnection?.authenticationUrl}
					helperText={`${translate(props.carConnectorForm.formState?.errors.mercedesConnection?.authenticationUrl?.message || ' ')}`}
				/>
			)} />
		</Grid>
		<Grid item xs={6}>	
			<Controller name="mercedesConnection.apiUrl" control={props.carConnectorForm.control} render={({ field }) => (
				<EvesTextbox {...field} id="apiUrl" label={`${translate('settings.car_connector.connection.api_url')} *`}
					fullWidth 
					// required={props.requiredFields['mercedesConnection.apiUrl']}
					variant="standard"
					error={!!props.carConnectorForm.formState?.errors?.mercedesConnection?.apiUrl}
					helperText={`${translate(props.carConnectorForm.formState?.errors?.mercedesConnection?.apiUrl?.message || ' ')}`}
				/>
			)} />
		</Grid>	
		<Grid item xs={6}>
			<Controller name="mercedesConnection.clientId" control={props.carConnectorForm.control} render={({ field }) => (
				<EvesTextbox {...field} id="clientId" label={`${translate('settings.car_connector.connection.client_id')} *`}
					data-cy="clientId"
					fullWidth
					// required={props.requiredFields['mercedesConnection.clientId']}
					variant="standard"
					autoComplete="new-password"
					error={!!props.carConnectorForm.formState?.errors.mercedesConnection?.clientId}
					helperText={`${translate(props.carConnectorForm.formState?.errors.mercedesConnection?.clientId?.message || ' ')}`}
				/>
			)} />
		</Grid>
		<Grid item xs={6}>
			<Controller name="mercedesConnection.clientSecret" control={props.carConnectorForm.control} render={({ field }) => (
				<EvesTextbox {...field} id="clientSecret" label={`${translate('settings.car_connector.connection.client_secret')} *`}
					data-cy="clientSecret"
					type="password"
					fullWidth
					// required={props.requiredFields['mercedesConnection.clientSecret']}
					variant="standard"
					autoComplete="new-password"
					error={!!props.carConnectorForm.formState?.errors.mercedesConnection?.clientSecret}
					helperText={`${translate(props.carConnectorForm.formState?.errors.mercedesConnection?.clientSecret?.message || ' ')}`}
				/>
			)} />
		</Grid>
	</Grid>;
};

export default MercedesConnection;